<div style="display: flex">
<div style="margin-right: 10px;" *ngIf="sourceColumn.isvisible || targetColumn.isvisible">

    <div style="display: flex; align-items: center;" *ngIf="sourceColumn.isvisible" [formGroup]="form">
       
    <app-autocomplete-field-with-matform
        [formControlName]="sourceColumn.jsonobject"
        [options]="sourceColumnsOptions"
        [placeholder]="sourceColumn.label"
        [(ngModel)]="viewModel.sourceColumn"
        [isrequired]="sourceColumn.isrequired"
    ></app-autocomplete-field-with-matform>
    <div style="width: 24px;margin-left: 5px;margin-bottom: -31px;">
        <img *ngIf="sourceColumn.isfillrules"
            (click)="onSetDefaultRule('sourceColumn')"
            src="assets/images/Fill Column Icon.png"
            alt="Set Default Rules"
            width="26px"
            height="26px">
    </div>
    </div>
    <!-- ✅ Force error below entire row using full-width div -->
    <div style="flex-basis: 100%; width: 100%;">
    <mat-error *ngIf="sourceColumn?.jsonobject && form.get(sourceColumn.jsonobject)?.hasError('required')">
        Source Field is required
    </mat-error>
    </div>
   
    <div style="display: flex; align-items: center;" *ngIf="targetColumn.isvisible" [formGroup]="form">
    <app-autocomplete-field-with-matform
        [formControlName]="targetColumn.jsonobject"
        [options]="targetColumnsOptions"
        [placeholder]="targetColumn.label"
        [(ngModel)]="viewModel.targetColumn"
        [isrequired]="targetColumn.isrequired"
    ></app-autocomplete-field-with-matform>
   <div style="width: 24px;margin-left: 5px;margin-bottom: -31px;">
    
        <img *ngIf="targetColumn.isfillrules"
            (click)="onSetDefaultRule('targetColumn')"
            src="assets/images/Fill Column Icon.png"
            alt="Set Default Rules"
            width="24px"
            height="28px">
    </div>
    </div>
 <div style="flex-basis: 100%; width: 100%;">
    <mat-error *ngIf="targetColumn?.jsonobject && form.get(targetColumn.jsonobject)?.hasError('required')">
    Target Field is required
    </mat-error>
    </div>
</div>

<div style="margin-right: 10px;" *ngIf="userColumn.isvisible || timeColumn.isvisible">
    <div style="display: flex; align-items: center;" *ngIf="userColumn.isvisible" [formGroup]="form">
    <app-autocomplete-field-with-matform
        [formControlName]="userColumn.jsonobject"
        [options]="sourceColumnsOptionsString"
        [placeholder]="userColumn.label"
        [(ngModel)]="viewModel.userColumn"
        [isrequired]="userColumn.isrequired"
    ></app-autocomplete-field-with-matform>
    
    </div>
   <div style="flex-basis: 100%; width: 100%;">
    <mat-error *ngIf="userColumn?.jsonobject && form.get(userColumn.jsonobject)?.hasError('required')">
    User Field is required
    </mat-error>
    </div>

     <div style="display: flex; align-items: center;" *ngIf="timeColumn.isvisible" [formGroup]="form">
    <app-autocomplete-field-with-matform
        [formControlName]="timeColumn.jsonobject"
        [options]="sourceColumnsOptionsTimeStamp"
        [placeholder]="timeColumn.label"
        [(ngModel)]="viewModel.timeColumn"
        [isrequired]="timeColumn.isrequired" (selectionChange)="onEventTimeColumn()"
    ></app-autocomplete-field-with-matform>
    
    </div>
   <div style="flex-basis: 100%; width: 100%;">
    <mat-error *ngIf="timeColumn?.jsonobject && form.get(timeColumn.jsonobject)?.hasError('required')">
    Timestamp Field is required
    </mat-error>
    </div>



</div>

<div style="margin-right: 10px; min-width: 190px;" *ngIf="sortInfo.isvisible">
    <mat-form-field style="width: 100%;" [floatLabel]="viewModel.sortInfo?.length ? 'always' : 'auto'" >
        <mat-label >{{sortInfo.label}}</mat-label>
        <mat-chip-listbox #chipList aria-label="Sort By">
            <mat-chip *ngFor="let sortInfo of viewModel.sortInfo" (removed)="removeSortInfo(sortInfo)">
                {{sortInfo.sortField}}
                <mat-icon class="primary-color-icon" style="font-size: 8px"
                    *ngIf="sortInfo.sortAscending" style="margin-left: 3px;">
                    keyboard_arrow_down
                </mat-icon>
                <mat-icon class="primary-color-icon" style="font-size: 8px"
                    *ngIf="!sortInfo.sortAscending" style="margin-left: 3px;">
                    keyboard_arrow_up
                </mat-icon>
                <button matChipRemove>
                    <mat-icon>cancel</mat-icon>
                </button>
            </mat-chip>
           
                <input style="cursor: pointer;" [readonly]="true" (click)="showSortBuilder()" matInput
                placeholder="Edit Columns..." #sortInfoInput [formControl]="sortCtrl" style="margin-left:10px;"
               >
        </mat-chip-listbox>
    </mat-form-field>
    <!-- Optional slots for a host transformer's compact controls, one under each of Sort By and
         Include in Results. The Sort By slot is zero width so it never widens that column; the
         Include in Results slot spans its column so a host can left- or right-align within it. -->
    <div style="width: 0; white-space: nowrap;">
        <ng-content select="[belowSortBy]"></ng-content>
    </div>
</div>

<div style="margin-right: 20px;min-width: 220px;" *ngIf="includeInResults.isvisible">
    <div>
       <mat-form-field style="width: 100%;" [floatLabel]="viewModel.includeInResults?.length ? 'always' : 'auto'" >
            <mat-label >{{includeInResults.label}}</mat-label>
            <mat-chip-listbox #chipListInclude aria-label="Include in Results Dashboard">
                <mat-chip *ngFor="let includeInfo of viewModel.includeInResults" (removed)="removeIncludeInfo(includeInfo)">
                    {{includeInfo.includeField}}
                    <button matChipRemove>
                        <mat-icon>cancel</mat-icon>
                    </button>
                </mat-chip>
             
                     <input style="cursor: pointer;" [readonly]="true" (click)="showIncludeBuilder()" matInput
                    placeholder="Edit Columns..." #sortInfoInput [formControl]="includeCtrl" style="margin-left:10px;"
                    >
            </mat-chip-listbox>
        </mat-form-field>
    </div>
    <div style="white-space: nowrap;">
        <ng-content select="[belowIncludeInResults]"></ng-content>
    </div>
</div>

<div style="margin-right: 10px;">
    <div *ngIf="sampleStart.isvisible">
        <mat-form-field  style="width: 100px;">
            <mat-label>{{sampleStart.label}}</mat-label>
            <input matInput placeholder="Sample Start" type="number" [min]="sampleStart.min" [max]="sampleStart.max"
                [(ngModel)]="viewModel.sampleStart" appIntegerPositiveOnly>
        </mat-form-field>
    </div>
    <div *ngIf="sampleEnd.isvisible">
        <mat-form-field  style="width: 100px;">
            <mat-label>{{sampleEnd.label}}</mat-label>
            <input matInput placeholder="Sample End" type="number" [min]="sampleEnd.min" [max]="sampleEnd.max"
                [(ngModel)]="viewModel.sampleEnd" appIntegerPositiveOnly>
        </mat-form-field>
    </div>
</div>

<div style="margin-right: 10px;">
    <div style="width: 180px;margin-top: 20px;" *ngIf="runAll.isvisible">
        <mat-slide-toggle style="float: right;" labelPosition="before" color="primary" [checked]="viewModel.runAll" (change)="onToggleRunAll($event)">{{runAll.label}}&nbsp;</mat-slide-toggle>
    </div>

    <div style="width: 180px" *ngIf="deleteMisses.isvisible">
        <mat-slide-toggle style="float: right;" labelPosition="before" color="primary" [checked]="viewModel.deleteMisses" (change)="onToggleDeleteMisses($event)">{{deleteMisses.label}}</mat-slide-toggle>
    </div>

    <div *ngIf="missName.isvisible">
        <mat-form-field  style="margin-left:22px;">
            <mat-label>{{missName.label}}</mat-label>
            <input matInput placeholder="Misses Name" [(ngModel)]="viewModel.missName">
        </mat-form-field>
    </div>
</div>
</div>


